import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-error-postal-modal',
    templateUrl: './error-postal-modal.component.html',
    styleUrls: ['./error-postal-modal.component.scss'],
    standalone: false
})
export class ErrorPostalModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
